var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://sos.cliniqueadmin.com/',
  baseApiUrl: 'https://sos.cliniqueadmin.com/api/'
};
export default Common;